/* unplugin-vue-components disabled */import script from "./FormGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormGroup.vue?vue&type=script&lang=ts&setup=true"

import "./FormGroup.vue?vue&type=style&index=0&id=4994e009&lang=scss"

const __exports__ = script;

export default __exports__